
import {Throttle} from "@/api/api";

type column = {
    prop: String;
    label: String;
    width: Number;
};

type parts = {
    name: string;
    mountings_type_pname: string;
    mountings_type_name: string;
    cost_price: number | null;
    selling_price: number | null;
    price_lock: number;
    mountings_brand_name: string;
    specification: string;
    mountings_unit_name: string;
    build_bonus_type: number;
    build_bonus_price: number | null;
    sell_bonus_type: number;
    sell_bonus_price: number | null;
    reappearance_type_name: string;
    describe: string;
    id: number;
};
type partsKey = keyof parts;
type formKey = keyof partsFormType;
let columnList: Array<column> = [
    {
        prop: "type_text",
        label: "入库类型",
        width: 75,
    },
    {
        prop: "ordersn",
        label: "关联单据",
        width: 75,
    },
    {
        prop: "create_time_text",
        label: "制单时间",
        width: 75,
    },
    {
        prop: "applicant_text",
        label: "制单人",
        width: 75,
    },
    {
        prop: "status_text",
        label: "状态",
        width: 75,
    },
    {
        prop: "reviewer_time_text",
        label: "审核时间",
        width: 75,
    },
    {
        prop: "reviewer_text",
        label: "审核人",
        width: 75,
    },
    {
        prop: "desc",
        label: "备注",
        width: 75,
    },
];

const purchaseColumn: Array<column> = [
  {
    prop: "name",
    label: "配件名称",
    width: 120,
  },
  {
    prop: "specification",
    label: "规格",
    width: 120,
  },
  {
    prop: "encoding",
    label: "编码",
    width: 80,
  },
  {
    prop: "mountings_type_p_name",
    label: "配件分类",
    width: 80,
  },
  {
    prop: "mountings_brand_name",
    label: "品牌",
    width: 80,
  },
  {
    prop: "mountings_unit_name",
    label: "单位",
    width: 80,
  },
  {
    prop: "price",
    label: "采购单价",
    width: 80,
  },
  {
    prop: "number",
    label: "数量",
    width: 80,
  },
  {
    prop: "price_total",
    label: "金额",
    width: 80,
  },
];

import {
    defineComponent,
    ref,
    reactive,
    inject,
    provide,
    onMounted,
    watch,
    onActivated,
} from "vue";
import {
    getManagementTable,
    getManagementTableAdd,
    getManagementTableEdit,
    getSetManagement,
    getSelectList, getPurchaseInfo, getLibraryInfo, permissionList,
} from "@/api/http";

import { Request } from "@/api/request";
import { validateInput, validateClass } from "@/assets/js/formRules";
import { partsFormType } from "@/assets/types/common";
import {
    useRoute,
    useRouter,
    onBeforeRouteUpdate,
    onBeforeRouteLeave,
} from "vue-router";
export default defineComponent({
    name: "warehouselibraryList",
    setup() {
        const setTitle: any = inject("setTitle");

        const headClass = inject("headClass");
        let pageSize = ref(10),
            currentPage = ref(1),
            tableData = ref([] as Array<parts>),
            total = ref(0),
            loading = ref(true),
            type = ref(""),
            route: any = useRoute(),
            Router: any = useRouter(),
            roleList = ref({} as any),
            // 筛选
            selectGroup = reactive({
                status: "",
                build_bonus_price: "",
                return_cash_plan: "",
                mountings_type_pname: "",
                mountings_type_name: "",
                mountings_brand_name: "",
                search: "",
            }),
            select = reactive({
                mountings_ptype_data: [],
                mountings_type_data: [],
                reappearance_type_data: [],
                mountings_brand_data: [],
                mountings_unit_data: [],
            }),
            remote_loading = ref(false),
            screenParameter: any = reactive({
              page: currentPage.value,
              pagesize: pageSize.value,
              time_type: '',
              search: '',
              status: '',
              type: '',
              start_time: '',
              end_time: ''
            }),
            dialogFormVisible = ref(false),
            detaildia_show = ref(false),
            detailTable = ref([] as Array<any>),
            purchaseDetail = ref([] as any),
            isMountings = ref(false),
            dialogTitle = ref("新增配件"),
            formRef = ref(null),
            form = ref({
                name: "",
                mountings_type_pid: null,
                mountings_type_id: null,
                cost_price: null,
                selling_price: null,
                price_lock: 1,
                mountings_brand_id: null,
                specification: "",
                encoding: null,
                unit_id: null,
                build_bonus_type: 1,
                build_bonus_price: null,
                sell_bonus_type: 1,
                sell_bonus_price: null,
                return_cash_plan: null,
                describe: "",
            } as partsFormType),
            commissionType = ref(["固定金额", "业绩比例", "毛利比例"]),
            isEdit = ref(false),
            rules = reactive({
                name: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("请输入配件名称", value, callback);
                        },
                        trigger: "change",
                    },
                ],
                class: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: undefined,
                            callback: Function
                        ) => {
                            validateClass(rule, callback, form);
                        },
                        trigger: "change",
                    },
                ],
                cost_price: [
                    { required: true, message: "必填", trigger: "change" },
                ],
                mountings_type_pid: [
                    { required: true, message: "必填", trigger: "change" },
                ],
                price: [
                    {
                        required: true,
                        validator: (
                            rule: any,
                            value: string,
                            callback: Function
                        ) => {
                            validateInput("请输入成本价", value, callback);
                        },
                        trigger: "change",
                    },
                ],
            });
        let handleSizeChange = (value: number): void => {
                pageSize.value = value;
                getTableData();
            },
            handleCurrentChange = (pageSize: number): void => {
                currentPage.value = pageSize;
                getTableData();
            },
            getTableData = (): void => {
                loading.value = true;
                //console.log(currentPage.value)
                let url = type.value=="1"?'warehouse_exceed':'warehouse_libraryList';
                let mydata = {
                    type:1,
                    role_name:url,
                };
                permissionList(mydata).then((res:any)=>{
                    roleList.value = res?.content?.list || 0;
                });
                Request.axiosInstance({
                    url: "adminapi/Warehouse/libraryList",
                    data: {
                      library_type: type.value,
                        ...screenParameter,
                        page: currentPage.value,
                        pagesize: pageSize.value,
                    },
                }).then((res: any) => {
                    tableData.value = res?.content?.list || [];
                    loading.value = false;
                    total.value = res?.content?.total || 0;
                }).catch(() => {
                  loading.value = false;
                });
            },
            getSelectData = (data: {
                search?: string;
                type_pid?: number | null;
            }) => {
                getSelectList(data).then((res: any) => {
                    Object.assign(select, res?.content || {});
                    remote_loading.value = false;
                });
            },
            screenChange = () => {
              getTableData();
            },
            changeClick = (row:any)=>{
            if (row.type == 4){
                //退货出库
                _option('/warehouse/editReturnWarehouse', {
                    my_type:type.value,
                    uid: row.id,
                    ...row
                })
            } else {
                if (type.value=="1"){
                    _option('/warehouse/createOutBill', { my_type:type.value,
                        uid: row.id,
                        ...row })
                }else {
                    _option('/warehouse/createInBill', { my_type:type.value,
                        uid: row.id,
                        ...row })
                }
                // _option('/warehouse/create', {
                //     my_type:type.value,
                //     uid: row.id,
                //     ...row
                // })
            }
            
            },
            selectChange = (e: string | Array<Date> | Array<number>, key: string): void => {
                // screenParameter[key] = e;
              if (!e){
                if (key == 'time'){
                  delete screenParameter["start_time"];
                  delete screenParameter["end_time"];
                } else {
                  delete screenParameter[key];
                }
              } else {
                if (key == 'time'){
                  screenParameter["start_time"] =
                      (e[0] as Date).getTime() / 1000;
                  screenParameter["end_time"] =
                      (e[1] as Date).getTime() / 1000;
                } else {
                  screenParameter[key] = e;
                  console.log('增加了属性-----',key,'---',e);
                }
              }
                getTableData();
            },
            remoteBrand = (e: string) => {
                remote_loading.value = true;
                getSelectData({ search: e });
            },
            formSelectChange = (e: number) => {
                getSelectData({ type_pid: e });
                form.value.mountings_type_id = null;
            },
            bonusSelectChange = (type: boolean) => {
                if (type) {
                    form.value.build_bonus_price = null;
                } else {
                    form.value.sell_bonus_price = null;
                }
            },
            brandBlur = (type: boolean) => {
                if (type) {
                    if (!selectGroup.mountings_brand_name) {
                        getSelectData({});
                    }
                } else {
                    if (!form.value.mountings_brand_id) {
                        getSelectData({});
                    }
                }
            },
            columnChange = (
                item: partsFormType & { id: number; status: number },
                type: boolean
            ): void => {
                if (type) {
                    dialogTitle.value = "编辑配件";
                    isEdit.value = true;
                    dialogFormVisible.value = true;
                    let data: any = { ...form.value, id: 0 };
                    Object.keys(data).forEach((key) => {
                        data[key as formKey] = item[key as formKey];
                    });
                    form.value = data;
                    getSelectData({ type_pid: form.value.mountings_type_pid });
                } else {
                    getSetManagement({
                        id: item.id,
                        status: item.status == 1 ? 0 : 1,
                    }).then((res) => getTableData());
                }
            },
            // 点击单据编号触发
            bindPurchaseInfo = (id: number) => {
              //门店ID【当为总店时必传】
              let userinfo;
              let user_info = localStorage.getItem('user_info');
              if(user_info){
                userinfo = JSON.parse(user_info);
              }
              let data = {};
              if (userinfo.store_id == 0) {
                data = {
                  store_id:'store_id',
                  id
                }
              } else {
                data = {
                  id
                }
              }
              getLibraryInfo(data).then((res: any) => {
                if (res.status == 200) {
                  let info = res.content.info;
                  let my_type;
                  let takeaway_text;
                  if (type.value == "1") {
                    my_type = "出库类型";
                    takeaway_text = '领料人';
                  } else {
                    my_type = "入库类型";
                    takeaway_text = '退料人';
                  }
                  if(info) {
                    let arr = [] as Array<any>;
                    if (info.type_text == '采购入库'){
                      arr = [[
                        '单据编号',
                        info.record_code,
                        '状态',
                        info.status_text,
                        my_type,
                        info.type_text,
                        '关联单据',
                        info.ordersn,
                      ],[
                        '供应商',
                        info.supplier,
                        '采购金额',
                        info.total_price,
                        '采购员',
                        info.employee_text,
                        '采购日期',
                        info.purchase_time_text,
                      ],[
                        '制单时间',
                        info.create_time_text,
                        '制单人',
                        info.applicant_text,
                        '审核时间',
                        info.reviewer_time_text,
                        '审核人',
                        info.reviewer_text,
                      ],[
                        '成本承担部门',
                        info.branch_name,
                        '备注',
                        info.desc,
                      ]];
                    } else if (info.type_text == '退料入库' || info.type_text == '领料出库'){
                      arr = [[
                        '单据编号',
                        info.record_code,
                        '状态',
                        info.status_text,
                        my_type,
                        info.type_text,
                        '关联单据',
                        info.ordersn,
                      ],[
                        '车牌号码',
                        info.car_name,
                        '品牌车型',
                        info.category_name,
                        '接车人',
                        info.meet_vehicle,
                        takeaway_text,
                        info.takeaway_text,
                      ],[
                        '制单时间',
                        info.create_time_text,
                        '制单人',
                        info.applicant_text,
                        '审核时间',
                        info.reviewer_time_text,
                        '审核人',
                        info.reviewer_text,
                      ],[
                        '成本承担部门',
                        info.branch_name,
                        '备注',
                        info.desc,
                      ]];
                    } else if (info.type_text == '盘盈入库' || info.type_text == '其它入库' || info.type_text == '盘亏出库' || info.type_text == '退货出库' || info.type_text == '配件销售出库' || info.type_text == '其它出库'){
                      arr = [[
                        '单据编号',
                        info.record_code,
                        '状态',
                        info.status_text,
                        my_type,
                        info.type_text,
                        '关联单据',
                        info.ordersn,
                      ],[
                        '制单时间',
                        info.create_time_text,
                        '制单人',
                        info.applicant_text,
                        '审核时间',
                        info.reviewer_time_text,
                        '审核人',
                        info.reviewer_text,
                      ],[
                        '成本承担部门',
                        info.branch_name,
                        '备注',
                        info.desc,
                      ]];
                    } else if (info.type_text == '辅料退料入库' || info.type_text == '辅料领料出库') {
                      arr = [[
                        '单据编号',
                        info.record_code,
                        '状态',
                        info.status_text,
                        my_type,
                        info.type_text,
                        '关联单据',
                        info.ordersn,
                      ],[
                        '制单时间',
                        info.create_time_text,
                        '制单人',
                        info.applicant_text,
                        '审核时间',
                        info.reviewer_time_text,
                        '审核人',
                        info.reviewer_text,
                      ],[
                        takeaway_text,
                        info.takeaway_text,
                        '成本承担部门',
                        info.branch_name,
                        '备注',
                        info.desc,
                      ]];
                    };

                    detailTable.value = arr;
                    purchaseDetail.value = res.content.info;
                    detaildia_show.value = true;
                    if(res.content.info.parts_list.length > 0){
                      isMountings.value = true
                    }
                  }
                }
              });
            },
            getSummaries = (param: any, type: number): Array<string> => {
              const { columns, data } = param;
              const sums: any = [];
              const propArr = [
                "number",
                "price_total",
              ];
              columns.forEach((column: any, index: number) => {
                if (index === 0) {
                  sums[index] = "";
                  return;
                }
                const values = data.map((item: any) =>
                    Number(item[column.property])
                );
                if (
                    propArr.findIndex((item: any) => {
                      return item == column.property;
                    }) > -1
                ) {
                  // 增加合计项
                  switch (type) {
                      // 配件合计
                    case 1:
                      if (column.property == "price_total") {
                        sums[index] = purchaseDetail.value.total_price;
                      } else {
                        sums[index] = purchaseDetail.value.total_number;
                      }
                      break;
                  }
                  if(column.property == "number"){
                    sums[index] = `${sums[index]}`;
                  }else{
                    sums[index] = `¥${sums[index]}`;
                  }
                } else {
                  sums[index] = "";
                }
              });
              return sums;
            },
            submitForm = (): void => {
                (formRef.value as any).validate((valid: boolean) => {
                    if (valid) {
                        if (isEdit.value) {
                            getManagementTableEdit(form.value).then((res) =>
                                getTableData()
                            );
                        } else {
                            getManagementTableAdd(form.value).then((res) =>
                                getTableData()
                            );
                        }
                    }
                    dialogFormVisible.value = !valid;
                });
            },
            onload = (name:any) => {
                type.value = name == "warehouselibraryList" ? "2" : "1";//2入库单 1出库单
                if (!type.value) return;
                //切换页面的时候重置数据
              currentPage.value = 1;
              pageSize.value = 10;
              screenParameter.time_type = '';
              screenParameter.search = '';
              screenParameter.status = '';
              screenParameter.type = '';
              screenParameter.start_time = '';
              screenParameter.end_time = '';

                setTitle([type.value == "1" ? "出库单" : "入库单"]);
                // console.log(columnList)
                if (type.value == "1") {
                    columnList[0].label = "出库类型";
                } else {
                    columnList[0].label = "入库类型";
                }
                getTableData();
            },
            _option = (url: string, data: any) => {
                Router.push({
                    path: url,
                    query: data,
                });
            },
            createBill = (()=>{
                if (type.value=="1"){
                    _option('/warehouse/createOutBill', { my_type:type })
                }else {
                    _option('/warehouse/createInBill', { my_type:type })
                }
            }),
            _libraryUps = new Throttle().use((id: number, status: number) => {
                Request.axiosInstance({
                    url: "adminapi/Warehouse/libraryUps",
                    data: { id, status },
                }).then((res: any) => {
                    getTableData();
                });
            },2000);
            // _libraryUps = (id: number, status: number) => {
            //     Request.axiosInstance({
            //         url: "adminapi/Warehouse/libraryUps",
            //         data: { id, status },
            //     }).then((res: any) => {
            //         getTableData();
            //     });
            // };
        onMounted(() => {
            onload(route.name )
            getSelectData({});
        });
        onBeforeRouteLeave((to, form) => {
            onload(to.name);
        });

        watch(dialogFormVisible, (newValue, oldValue) => {
            if (oldValue) {
                form.value = {
                    name: "",
                    mountings_type_pid: null,
                    mountings_type_id: null,
                    cost_price: null,
                    selling_price: null,
                    price_lock: 1,
                    mountings_brand_id: null,
                    specification: "",
                    unit_id: null,
                    encoding: null,
                    build_bonus_type: 1,
                    build_bonus_price: null,
                    sell_bonus_type: 1,
                    sell_bonus_price: null,
                    return_cash_plan: null,
                    describe: "",
                };
                isEdit.value = false;
                dialogTitle.value = "新增配件";
                (formRef.value as any).resetFields();
            }
        });

        return {
            columnList,
            headClass,
            pageSize,
            currentPage,
            tableData,
            total,
            loading,
            selectGroup,
            select,
            remote_loading,
            dialogFormVisible,
            dialogTitle,
            formRef,
            form,
            commissionType,
            isEdit,
            rules,
            handleSizeChange,
            handleCurrentChange,
            selectChange,
            remoteBrand,
            formSelectChange,
            bonusSelectChange,
            brandBlur,
            columnChange,
            submitForm,
            type,
            _option,
            _libraryUps,
          bindPurchaseInfo,
          detaildia_show,
          detailTable,
          purchaseDetail,
          purchaseColumn,
          getSummaries,
          isMountings,
          screenParameter,
          screenChange,
            changeClick,
            roleList,
            createBill
        };
    },
});
